import React from "react";
import {
  StyledSearchBarContainer,
  StyledSearchBarContainerContent,
  StyledSearchBarContent,
} from "./search-bar.styles";
import SearchInput, { SearchChangeEventHandler } from "./search-input";

export interface SearchBarProps {
  onChange: SearchChangeEventHandler;
}

const SearchBar = ({ onChange }: SearchBarProps) => (
  <StyledSearchBarContainer>
    <StyledSearchBarContainerContent>
      <StyledSearchBarContent>
        <SearchInput onChange={onChange} />
      </StyledSearchBarContent>
    </StyledSearchBarContainerContent>
  </StyledSearchBarContainer>
);

export default React.memo(SearchBar);
